<template>
  <div class="speaker-list">
    <div class="speaker-list-item" v-for="s in speakers" :key="s._id">
      <div class="speaker-img"><img :src="s.imgPath"/></div>
      <div class="speaker-info-wrapper">
        <div class="speaker-name">{{s.name}}</div>
        <div class="speaker-title">{{s.title}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import $config from '@/config'

  export default {
    name: 'Speakers',
    data() {
      return {
        speakerImageUrl: null
      }
    },
    computed: {
      ...mapGetters('webcast', {
        webcast: 'getCopy'
      }),
      ...mapGetters('speakers', {
        findSpeakersInStore: 'find'
      }),
      speakers(){
        console.log(this.findSpeakersInStore({webcastId:this.webcast._id}).data);
        return this.findSpeakersInStore({webcastId:this.webcast._id}).data
      }
    },
    methods: {
      ...mapActions('speakers', {
  			findSpeakerAction: 'find',
      	updateSpeakerAction: 'update',
      	createSpeakerAction: 'create',
      	removeSpeakerAction: 'remove'
    	})
    },
    created() {
      this.findSpeakerAction({query:{'webcastId':this.webcast._id}});
    },
  }
</script>

<style lang="less">
.speaker-list{

}
.speaker-list-item{
  height: 84px;
  margin-bottom:12px;
}
.speaker-img{
  float:left;
  margin-right:12px;
  img{
    width:72px;
    height:72px;
    border-radius: 48px;
  }
}
.speaker-info-wrapper{
  padding-left:84px;
  padding-top: 14px;
}
.speaker-name{
  font-size:14px;
}
.speaker-actions{
  float: right;
  top: -32px;
  position: relative;
}
</style>
